export default __webpack_public_path__ + "media/images/mission-bleu-f5569ab93a4f51a59fd9afcfa1d02758.png";